const FirebaseConfig = {
  apiKey: "AIzaSyB-BY8NUIQxLbEBHuTUwhBxXKZn4R7x0AA",
  authDomain: "betmoneymaker-3c70b.firebaseapp.com",
  databaseURL: "https://betmoneymaker-3c70b.firebaseio.com",
  projectId: "betmoneymaker-3c70b",
  storageBucket: "betmoneymaker-3c70b.appspot.com",
  messagingSenderId: "31666291935",
  appId: "1:31666291935:web:fb454d8430b5c92913156a"
  };

module.exports = {FirebaseConfig}


/*
  apiKey: "AIzaSyB-BY8NUIQxLbEBHuTUwhBxXKZn4R7x0AA",
  authDomain: "betmoneymaker-3c70b.firebaseapp.com",
  databaseURL: "https://betmoneymaker-3c70b.firebaseio.com",
  projectId: "betmoneymaker-3c70b",
  storageBucket: "betmoneymaker-3c70b.appspot.com",
  messagingSenderId: "31666291935"

  apiKey: "AIzaSyBnAq5__KRoipZ3oMto7Rr-7yxgN3dIJuA",
  authDomain: "devbetmoneymaker.firebaseapp.com",
  databaseURL: "https://devbetmoneymaker.firebaseio.com",
  projectId: "devbetmoneymaker",
  storageBucket: "devbetmoneymaker.appspot.com",
  messagingSenderId: "665023844616"


 */



// WEBPACK FOOTER //
// ./src/config/prod.js